import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import { Button } from '@mui/material';
import LoadingView from '~common/components/loading-view';
import URLManager from '~common/lib/url-manager';
import Renderers from '~common/lib/renderers';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';

const styles = (theme: Theme): StyleRules => ({
  container:{
    display: 'flex',
  },
  loading: {
    flex:1,
  },
  taskCard: {
    width: '100%',
    background: theme.palette.background.paper,
    border: '1px solid #ccc',
    minHeight: 200
  },
  layoutCard: {
    width: '100%',
    background: theme.palette.background.paper,
    border: '1px solid #ccc',
    height: '100%'
  },
  caption: {
    textAlign: 'center',
    borderBottom: '1px solid #ccc',
    padding: 10,
    lineHeight: 1,
    minHeight: "1em"
  },
  contentArea: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardContent: {
    height: 'calc(100% - 60px)',
    flex: 1,
    margin: 0,
  },
  cardContentAggregation: {
    height: 'calc(100% - 45px)',
    flex: 1,
    margin: 0
  },
  countContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    //minHeight: 120,
    fontSize: '3.0rem',
    cursor: 'pointer'
  },
  templateContent: {
    //minHeight: 120
  },
  cardContentEven: {
    margin: '10px 15px 10px 15px',
    display: 'flex',
    justifyContent: 'space-around'
  },
  cardActions: {
    padding: 5,
  },
  
  // Make sure title is still centered after icon placment
  overlay: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255,255,255,0.5)',
    zIndex: 20,
    flexFlow: 'column',
    justifyContent: 'center'
  },
  confirmationButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 200,
    padding: 15,
    marginLeft: 30,
    marginRight: 30
  },
  deleteSaveButton: {
    backgroundColor: 'red'
  }
});

interface Props {
  element: any;
  elementType: any;
  caption: string;
  renderers: any;
  onElementsUpdate: Function;
  inEditMode?: boolean;
  chromeless?: boolean;
}

type State = {
  status: 'loading' | 'ready';
  data: any;
  error?: any;
  requiresConfirmation?: boolean;
  confirmationPolicyMessages?: Array<any>;
};

class DashboardElement extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
      data: null
    };
  }

  // UNSAFE_componentWillReceiveProps(
  //   newProps: Props & WithStyles<keyof typeof styles>
  // ) {}

  onCountClick = () => {
    const {data} = this.state;
    if (
      data &&
      data.element.fulfillmentCriteria &&
      data.element.elementAttributes &&
      data.element.elementAttributes.targetURL
    ) {
      const reducedForm = this.reduceCriteria(data.element.fulfillmentCriteria);

      var url: string = data.element.elementAttributes.targetURL;
      var crit = data.element.fulfillmentCriteria;
      delete crit.criteriaForm;
      delete crit.resultsForm;
      url += '?q=' + URLManager.getQueryStringValue(crit);
      window.location.href = url;
    }
  };

  reduceCriteria = (crit: any) => {
    delete crit['criteriaForm'];
    delete crit['resultsForm'];
  };

  getThresholdAttributes = (): any => {
    const {data} = this.state;
    const {element} = this.props;

    let attr = {};

    if (element.elementAttributes && element.elementAttributes.thresholds) {
      const thresholds = element.elementAttributes.thresholds;

      if (thresholds.defaultAttributes) {
        attr = thresholds.defaultAttributes;
      }
      if (thresholds.entries) {
        var sorted = thresholds.entries.sort((a, b) => {
          return a.value > b.value;
        });

        for (let i of sorted) {
          if (data) {
            if (i.floorValue <= data.content.count && i.attributes) {
              attr = i.attributes;
            }
          }
        }
      }
    }

    return attr;
  };

  initiateElementDelete = () => {
    this.setState({requiresConfirmation: true});
  };

  cancelElementDelete = () => {
    this.setState({requiresConfirmation: false});
  };

  handleElementDelete = () => {
    const {element} = this.props;
    if (element) {
      request
      .delete('/api/dashboards/' + element.id)
      .set('Content-Type', 'application/json')
      .send(JSON.stringify(element))
      // .send({resultsForm: this.props.resultsForm})
      .then((response: any) => {
        const elements = response.body.elements;
        const elementTypes = response.body.elementTypes;
        const layouts = response.body.layouts;
        
        if (this.props.onElementsUpdate) {
          this.props.onElementsUpdate(elements, elementTypes, layouts)
        }



        this.setState({
          status: 'ready',
        });
      })
      .catch((err: any) => {
        this.setState({
          error: err
        });
      });

      this.setState({requiresConfirmation: false});
      // alert('TODO:  call the custom remove dashboard handler');
    }
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {
      chromeless,
      element,
      elementType,
      renderers,
      inEditMode
    } = this.props;
    const {status, data, requiresConfirmation, confirmationPolicyMessages} = this.state;

    var cardClass = classes.cardContent;
    var cardContent: any = null;

    switch (status) {
      case 'loading':
        return (
          <div key={this.props.caption} className={classes.container}>
            <LoadingView compact compact className={classes.loading} />
          </div>
        );

      default:
        if (element && element.elementTypeRel && element.elementTypeRel.uiAttributes && element.elementTypeRel.uiAttributes.elementRenderer) {
          const styleAttributes = this.getThresholdAttributes();

          let Renderer = Renderers.find(element.elementTypeRel.uiAttributes.elementRenderer);
          if (!Renderer) {
            
            Renderer = Renderers.find(
              elementType.uiAttributes['elementRenderer']
            );
          }




          if (Renderer) {
            cardContent = (
              <Renderer
                inEditMode={inEditMode}
                element={element}
                elementType={elementType}
              />
            );
          }
        }

        const linkURL: string = '';

        if (chromeless) {
          return <div key={}>{cardContent}</div>;
        } else {

          if (!cardContent) {
            return null;
          } else {
            let overlay: any = null;
            if (inEditMode) {
              if (requiresConfirmation) {
                var pmArea: any = null;
                if (confirmationPolicyMessages) {
                  switch (confirmationPolicyMessages.length) {
                    case 1:
                      var cm = confirmationPolicyMessages[0];
                      pmArea = <p>{cm.message}</p>;
                      break;
                    default:
                      pmList = confirmationPolicyMessages.map((pm) => {
                        return <li key={pm.path}>{pm.message}</li>;
                      });
                      pmArea = <ul key={pmArea.path}>{pmList}</ul>;
                  }
                } else {
                  pmArea = <p>Are you sure you want to delete this element?</p>;
                }

                overlay = (
                  <div className={classes.overlay}>
                    {pmArea}
                    <div className={classes.confirmationButtons}>
                      <Button
                        variant="contained"
                        color="inherit"
                        onClick={this.cancelElementDelete}
                        className={classes.deleteCancelButton}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleElementDelete}
                        className={classes.deleteSaveButton}>
                        Delete
                      </Button>
                    </div>
                  </div>
                );
              } else {
                overlay = <div className={classes.overlay} />;
              }
            }

            if(element.elementType == 'aggregation') {
              cardClass = classes.cardContentAggregation;
            }

            return (
              <div key={this.props.caption}
                className={classNames(
                  classes.layoutCard,
                  'icg-dashboard-card'
                )}>
                <Typography className={classes.caption} variant="h6">
                  {/* TODO: Center label regardless of */}
                  {element && element.scope == 'Private' && (
                    <i
                      style={{float: 'left', opacity: 0.2}}
                      className="fa fa-user"
                    />
                  )}
                  {element && element.scope == 'Global' && (
                    <i
                      style={{float: 'left', opacity: 0.2}}
                      className="fa fa-globe"
                    />
                  )}
                  {element && element.scope == 'Public' && (
                    <i
                      style={{float: 'left', opacity: 0.2}}
                      className="fa fa-users"
                    />
                  )}
                  <label style={{cursor: linkURL ? 'pointer' : 'default'}}>
                    {this.props.caption}
                  </label>
                  {inEditMode && element.scope != 'Global' && (
                    <i
                      onClick={this.initiateElementDelete}
                      style={{float: 'right', opacity: 0.5, cursor: 'pointer'}}
                      className="fa fa-trash"
                    />
                  )}
                </Typography>
                
                <div
                  className={classNames(cardClass, classes.contentArea)}
                  style={{position: 'relative'}}>
                  {cardContent}
                  {overlay}
                </div>
                
              </div>
            );
          }
        }
    }
  }
}

export default withStyles(styles)(DashboardElement);
